const tile = "_35stirxojd";

export { tile };
import "./atom.tile.style.linaria.module.css";
//# sourceMappingURL=atom.tile.style.js.map
